export default {
  REQUEST_EVENT: 'auth:request',
  LOGOUT_EVENT: 'auth:logout',
  LOGGED_IN_EVENT: 'auth:logged-in',
  LOGGED_OUT_EVENT: 'auth:logged-out',
  LOGIN_ERROR_EVENT: 'auth:login-error',
};
